﻿import ResourceHandler from './ResourceHandler';
import * as paths from './paths';

export default class StyleListControl {
    constructor(styleListContainer, rootUrl, settingsHandler) {
        this.rootUrl = rootUrl;
        this.styleListContainer = styleListContainer;
        this.filterId = 'style-list-filter';
        this.filterPartId = 'style-list-filter-part';
        this.filterExtraId = 'style-list-filter-extra';
        this.listId = 'style-list-list';
        this.filterStyleNameId = 'style-name-filter-id';
        this.filterStyleKeywordsId = 'style-keywords-filter-id';
        this.filterStyleButtonId = 'style-filter-button-id';
        this.resourcesHandler = new ResourceHandler(this.rootUrl);
        this.settingsHandler = settingsHandler;
        this.styles = {};

        this._init();
    }

    removeStyle(id, keyword) {
        let style = this.styles[keyword].find(row => { return row.Id == id });
        this.styles[keyword].splice(this.styles[keyword].indexOf(style), 1);
        let keywordRemoved = false;
        if (this.styles[keyword].length == 0) {
            delete this.styles[keyword];
            keywordRemoved = true;
        }

        document.querySelector('.style-item[data-ref="' + id + '"][data-ref-key="' + keyword + '"]').remove();

        if (keywordRemoved) {
            document.querySelector('.style-keyword-label-group[data-ref="' + keyword + '"]').remove();
            document.querySelector('.style-keyword-group[data-ref="' + keyword + '"]').remove();
        }
    }

    _init() {
        this.resourcesHandler.load().then(() => {
            let div = document.createElement('div');
            div.innerHTML = this._getTemplate();

            this.styleListContainer.append(div.firstChild);
            this._addFilterEvents();

            this._initList().then((result) => {
                let template = `<div class="style-list-wrapper">`;
                let keywords = {};

                if (result != null && result.length > 0) {
                    keywords[this.resourcesHandler.get('GenericStyle')] = [];

                    result.forEach(style => {
                        if (style.Keywords.length > 0) {
                            style.Keywords.forEach(keyword => {
                                if (keywords[keyword] == null) {
                                    keywords[keyword] = [];
                                }

                                keywords[keyword].push(style);
                            });
                        } else {
                            keywords[this.resourcesHandler.get('GenericStyle')].push(style);
                        }
                    });

                    Object.keys(keywords).forEach(keyword => {
                        template += `<div class="style-keyword-label-group form-row ml-2" data-ref="` + keyword + `">
                                        <label class="form-label">` + keyword + `</label>
                                     </div>
                                     <div class="style-keyword-group form-row" data-ref="` + keyword + `">`;
                        keywords[keyword].forEach(style => {
                            template += `<div class="style-item" data-ref="` + style.Id + `" data-ref-key="` + keyword + `">`;
                            template += this.settingsHandler.handleTemplateBefore(keyword, style);
                            template += `<div class="style-img-wrapper">`;
                            
                            if (style.RulesCount == null) {
                                template += `<img title="` + (style.Description != null && style.Description.trim() != '' ? style.Description : style.Name) + `" src="` + (this.rootUrl + paths.STYLE_PREVIEW_URL + style.Id + '_0.png') + `" class="style-preview"></img>`;
                            } else if (style.RulesCount == 1) {
                                template += `<img title="` + (style.Description != null && style.Description.trim() != '' ? style.Description : style.Name) + `" src="` + (this.rootUrl + paths.STYLE_PREVIEW_URL + style.Id + '_0.png') + `" class="style-preview"></img>`;
                            } else {
                                for (let i = 0; i < style.RulesCount; i++) {
                                    if (i < 4) {
                                        template += `<img title="` + (style.Description != null && style.Description.trim() != '' ? style.Description : style.Name) + `" src="` + (this.rootUrl + paths.STYLE_PREVIEW_URL + style.Id + '_' + i + '.png') + `" class="style-preview-multi"></img>`;
                                    } else {
                                        i = style.RulesCount;
                                    }
                                }
                            }

                            template += `</div>`;
                            
                            template += this.settingsHandler.handleTemplateAfter(keyword, style);
                            template += `<div class="style-label" title="` + style.Name + `">` + style.Name + `</div></div>`;
                        });

                        template += `</div>`;
                    });

                    template += `</div>`;
                }

                document.getElementById(this.listId).innerHTML = template;
                this.settingsHandler.handleExtra(this.filterExtraId);
                this.styles = keywords;
                this._addEventsForFilters();
                this._addEventsForStyles(keywords);
            });
        });
    }

    _addEventsForFilters() {
        document.getElementById(this.filterStyleNameId).addEventListener('keyup', () => {
            this._filterStyles();
        });

        document.getElementById(this.filterStyleNameId).addEventListener('paste', () => {
            this._filterStyles();
        });

        document.getElementById('style-select-all').addEventListener('change', () => {
            let isChecked = document.getElementById('style-select-all').checked;
            [...document.querySelectorAll('.style-check-input')].forEach(x => { x.checked = isChecked });
        });
    }

    _filterStyles() {
        let name = document.getElementById(this.filterStyleNameId).value;
        let keywords = $('#' + this.filterStyleKeywordsId).data('kendoMultiSelect').value();

        $('.style-item').hide();
        $('.style-keyword-label-group').hide();
        $('.style-keyword-group').hide();

        let keys = Object.keys(this.styles);

        keys.forEach(keyword => {
            if (keywords.length == 0 || keywords.indexOf(keyword) >= 0) {
                let hasChildren = false;
                this.styles[keyword].forEach(style => {
                    if (name == null || name.trim() == '' || style.Name.toLowerCase().indexOf(name.trim().toLowerCase()) >= 0) {
                        $('.style-item[data-ref="' + style.Id + '"][data-ref-key="' + keyword + '"]').show();
                        hasChildren = true;
                    }
                });

                if (hasChildren) {
                    $('.style-keyword-label-group[data-ref="' + keyword + '"]').show();
                    $('.style-keyword-group[data-ref="' + keyword + '"]').show();
                }
            }
        });
    }

    _addEventsForStyles(keywords) {
        Object.keys(keywords).forEach(keyword => {
            keywords[keyword].forEach(style => {
                this.settingsHandler.addEventsForStyle(keyword, style);
            });
        });
    }

    _initList() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "POST",
                url: this.rootUrl + paths.STYLE_LIST_URL,
                async: true,
                data: '{}',
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    resolve(result);
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    _addFilterEvents() {
        $('#' + this.filterStyleKeywordsId).kendoMultiSelect({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + paths.STYLE_KEYWORDS;
                        }
                    }
                }
            },
            change: () => {
                this._filterStyles();
            },
            dataBound: (evt) => {
                if (evt.sender.dataSource.data().find(row => { return row.Id == this.resourcesHandler.get('GenericStyle') }) == null) {
                    evt.sender.dataSource.add({ Name: this.resourcesHandler.get('GenericStyle'), Id: this.resourcesHandler.get('GenericStyle') });
                }
            }
        });
    }

    _getTemplate() {
        return `<div class="col-sm-12">
                    <div class="card m-0">
                        <div class="card-body">
                            <div id="` + this.filterId + `">
                                <div id="` + this.filterPartId + `" class="form-row mb-4 style-filter-part">
                                    <div class="col-xl-3 style-name-group">
                                        <div class="form-group">
                                            <label class="form-label">` + this.resourcesHandler.get('StyleName') + `</label>
                                            <input type="text" class="form-control" id="` + this.filterStyleNameId + `">
                                        </div>
                                    </div>
                                    <div class="col-xl-3 style-keywords-group">
                                        <div class="form-group">
                                            <label class="form-label">` + this.resourcesHandler.get('StyleKeywords') + `</label>
                                            <div class="form-control" id="` + this.filterStyleKeywordsId + `"></div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 align-content-center">
                                        <div class="form-group" id="` + this.filterExtraId + `">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="style-select-all-group">
                                <div class="custom-control custom-checkbox" style="margin-left: 4px;">
                                    <input class="custom-control-input style-check-input" type="checkbox" id="style-select-all"></input>
                                    <label class="custom-control-label" for="style-select-all">` + this.resourcesHandler.get('SelectAll') + `</label>
                                </div>
                            </div>
                            <div id="` + this.listId + `">
                            </div>
                        </div>
                    </div>
                </div>`;
    }
}